import styled from 'styled-components';
import { Box } from 'grommet';
import { TableStyled } from '../shared/table.css.js';

export const TemplateListStyled = styled(Box)`
  ${ TableStyled }
`;